import { TextMessage } from './TextMessage'
import { ChatMessage } from 'types/chat-message'
import { messagesSelectors } from 'store/messages'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import _ from 'lodash'
import { generateSrcFromEmail } from 'utils/avatar'
import { AttachmentMessage, fromUpload } from 'components/messages/AttachmentMessage'
import { getBorderStyle } from 'utils/index'

export type BotMessageProps = {
  messageItem: ChatMessage
  startsSequence: boolean
  endsSequence: boolean
  index: number
}

export const OperatorMessage = ({ messageItem, startsSequence, endsSequence }: BotMessageProps) => {
  const currentChatParticipants = useSelector(messagesSelectors.currentChatParticipants)
  const borderClass = getBorderStyle(startsSequence, endsSequence)

  const operator = useMemo(() => {
    return _.find(currentChatParticipants, (participant) => participant.userId === messageItem.senderId)
  }, [currentChatParticipants, messageItem])

  return (
    <div className={'tw-flex tw-flex-col tw-gap-1'}>
      <TextMessage
        startsSequence={startsSequence}
        endsSequence={endsSequence}
        showBotAvatar={false}
        isOperator={true}
        img={
          <img
            src={generateSrcFromEmail(operator?.user?.email)}
            alt={operator?.user?.email || 'operator avatar'}
            className={'tw-rounded-full'}
          />
        }
        text={messageItem.message}
        key={`${messageItem._id}_operator_text`}
        messageItem={messageItem}
      />
      {messageItem.operatorAttachments?.map((att) => (
        <AttachmentMessage attachment={fromUpload(att)} key={att._id} borderClass={borderClass} />
      ))}
    </div>
  )
}
